module.exports = __webpack_public_path__ + "media/stylesheets/images/icons/icon-mind-447677a2897070cfd6cd89838b5ffb22.svg";